<template>
  <div class="air-upload-file flex vertical">
    <div class="upload-container">
      <el-upload
        ref="upload"
        drag
        :multiple="multiple"
        :action="uploadUrl"
        :file-list="fileList"
        :on-success="fileUploadSuccess"
        :on-error="fileUploadError"
        :on-remove="handleRemove"
        :on-preview="handlePreview"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <div class="upload-body flex vertical acenter">
          <img src="@/air/assets/img/icon/file.png" />
          <el-button plain class="button-v2">{{ $t('uploadFiles') }}</el-button>
          <span class="upload-tips">{{ uploadFilesTip ? uploadFilesTip : $t('uploadFilesTip') }}</span>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import * as fileApi from '@/api/user/user';
  import { downloadFile } from '@/util/util';
  import { validatenull } from "@/util/validate";
  export default {
    name: "AirUploadFile",
    props: {
      fileList: {
        type: Array,
        default() {
          return []
        }
      },
      fileIds: {
        type: String,
        default: ''
      }
    },
    watch: {
      fileIds: {
        handler(newVal, oldVal) {
          if (this.isInit && newVal) {
            this.getFileList();
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        uploadUrl: '/api/file', //上传地址
        isInit: true
      }
    },
    methods: {
      getFileList(){
        let fileIds = [];
        let fileList = JSON.parse(JSON.stringify(this.fileList));
        if (this.fileIds) {
          fileIds = this.fileIds.split(",");
        } else  if (fileList && fileList.length > 0) {
          fileIds = fileList.map(item => item.fileId);
        }
        if (fileIds.length > 0) {
          this.loading = true;
          let resArr = [];
          for (let i = 0; i < fileIds.length; i++) {
            if (!validatenull(fileIds[i])) {
              resArr.push(this.getFileInfo(fileIds[i]));
            }
          }
          Promise.all([...resArr])
            .then(result => {
              this.loading = false;
              const fileList = result.filter(item => !validatenull(item) && !validatenull(item.name));
              this.updateFile(fileList, fileIds, 'success', {});
            })
            .catch(error => {
              this.loading = false;
            })
        }
      },
      getFileInfo(fileId) {
        return new Promise((resolve, reject) => {
          fileApi.getFileInfo(fileId).then(res => {
            const file = JSON.parse(JSON.stringify(res.data.data));
            file.fileId = file.id;
            resolve(file);
          })
        })
      },
      fileUploadSuccess(res, file, fileList) {
        if (!res) {
          this.$msgError('文件上传失败！')
          return
        }
        this.isInit = false;
        let fileListFilter = JSON.parse(JSON.stringify(fileList));
        let fileIds = [];
        fileListFilter.forEach(item => {
          if (item.response) {
            item.fileId = item.response.fileId;
          }
          if (item.fileId) {
            fileIds.push(item.fileId);
          }
          delete item.response;
        })
        this.updateFile(fileListFilter, fileIds, 'success', file);
      },
      updateFile(fileList = [], fileIds = [], type = 'success', file = {}) {
        this.$emit('update:fileList', fileList);
        this.$emit('update:fileIds', fileIds.join(','));
        this.$emit('change', {file, fileList: fileList, type})
      },
      fileUploadError(err, file, fileList) {
        this.$msgError("文件上传异常!")
      },
      handleRemove(file, fileList) {
        this.isInit = false;
        let fileIds = fileList.map(item => item.fileId);
        this.updateFile(fileList, fileIds, 'remove', file);
      },
      handlePreview(file) {
        let fileId = '';
        if (file.fileId) {
          fileId = file.fileId;
        } else if (file.response) {
          fileId = file.response.fileId;
        }
        fileApi.downLoadFile(fileId).then(res => {
          downloadFile(res);
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .air-upload-file {
    .upload-container {
      width: 100%;
      background: #FFFFFF;
      border-radius: 6px;
      padding: 10px 0;
      
      ::v-deep .el-upload {
        width: 100%;
        
        .el-upload-dragger {
          width: 100%;
        }
        .upload-body {
          img {
            width: 60px;
            height: 50px;
            margin-top: 22px;
            margin-bottom: 14px;
          }
          .upload-tips {
            height: 14px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3E475D;
            line-height: 14px;
            margin-top: 20px;
          }
        }
      }
      ::v-deep .el-upload-list__item-name {
        text-align: left;
      }
    }
  }
</style>
